"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateRules = evaluateRules;
exports.createValidityVisitor = createValidityVisitor;
const lodash_1 = __importDefault(require("lodash"));
const evaluateConditions_1 = require("../../../condition-engine/evaluateConditions");
const queries_1 = require("../../../condition-engine/queries");
const validationData_1 = require("../../../condition-engine/validationData");
const helpers_1 = require("../../answers/helpers");
const validityRule_1 = require("./validityRule");
function evaluateRules(rules, answersResolver, repeatedInstanceIdentifiers, timezone, currentDateOverride, fieldTypeValidation) {
    const validRules = [];
    const invalidRules = [];
    let validationData = {};
    for (const rule of rules) {
        const { isValid } = (0, evaluateConditions_1.evaluateConditions)(rule.conditions, answersResolver, repeatedInstanceIdentifiers, timezone, currentDateOverride);
        const evaluatedMessageParams = rule.messageParams &&
            evaluateMessageParams(rule.messageParams, answersResolver, repeatedInstanceIdentifiers, timezone, currentDateOverride);
        if (isValid) {
            validRules.push({ isValid, message: rule.message, evaluatedMessageParams });
        }
        else {
            invalidRules.push({ isValid, message: rule.message, evaluatedMessageParams });
        }
    }
    if (fieldTypeValidation) {
        validationData = {
            ...(0, validationData_1.generateValidationDataFromValidationType)(fieldTypeValidation, timezone, validationData, currentDateOverride),
        };
    }
    return { validRules, invalidRules, validationData };
}
function evaluateMessageParams(messageParams, answersResolver, repeatedInstanceIdentifiers, timezone, currentDateOverride) {
    return lodash_1.default.mapValues(messageParams, (value) => {
        if ((0, validityRule_1.isMessageQuery)(value)) {
            return (0, queries_1.evaluateQuery)(value.fromQuery, answersResolver, repeatedInstanceIdentifiers, timezone, {}, currentDateOverride);
        }
        return value;
    });
}
function createValidityVisitor({ processFieldEvaluation }, answersResolver, timezone, currentDateOverride) {
    const visitField = (navigation, { node, answersResolver, repeatedInstanceIdentifiers }) => {
        const nodeWithEvaluatedVisibility = node;
        if (!nodeWithEvaluatedVisibility.visible) {
            // Invisible nodes cannot be invalid
            return;
        }
        const { invalidRules, validationData } = evaluateRules(node.validIf ?? [], answersResolver, repeatedInstanceIdentifiers, timezone, currentDateOverride, node?.validation?.type);
        const fieldAnswer = answersResolver.usingNodeId().getAnswer(node.blueprintId, repeatedInstanceIdentifiers);
        processFieldEvaluation({
            node: node,
            hasBeenAnswered: (0, helpers_1.hasBeenAnswered)(fieldAnswer),
            brokenRules: invalidRules,
            validationData,
        });
    };
    return {
        visitDefault: (navigation) => navigation.visitChildren(),
        visitField,
        complete: () => { },
    };
}
